/**
 * @class
 * @explain    默认登录方法
 * @author     李旭
 * @time       2024-07-01
 */
// auth.js
import Encrypt from './Encrypt'

const strToBytes = (str) =>
{
  const bytes = []
  for (let i = 0; i < str.length; i++) bytes.push(str.charCodeAt(i))
  return bytes
}
  
const bytesToStr = (bytes) =>
{
  const str = []
  for (let i = 0; i < bytes.length; i++) str.push(String.fromCharCode(bytes[i]))
  return str.join('')
}

export const initAuth = async() =>
{
  try
  {
    const params = {
      cmd: 'login',
      username: Encrypt.encrypt('admin', bytesToStr(strToBytes(window.loginKey))),
      password: Encrypt.encrypt('Dxzx123456', bytesToStr(strToBytes(window.loginKey))),
      type: 1,
      sys: 11
    }
    const res = await window.post.getLogin(params)
    cx.http.setAuth(res.Authorization)
  }
  catch (e)
  {
    console.error('登录失败:', e)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/app/layout/auth.js